import { render, staticRenderFns } from "./CustomizeMeasures.vue?vue&type=template&id=1b56f41a&scoped=true&"
import script from "./CustomizeMeasures.vue?vue&type=script&lang=js&"
export * from "./CustomizeMeasures.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeMeasures.vue?vue&type=style&index=0&id=1b56f41a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56f41a",
  null
  
)

export default component.exports